export default __webpack_public_path__ + "static/media/coletivo-1.696d3a01.jpeg";